export default {
  'app.console.nodata': 'Sin datos',
  'app.console.recents': 'Recientes',
  'app.console.recents.nodata': 'No hay datos disponibles. Por favor, active primero el servicio',
  'app.console.channel': 'Servicio a activar',
  'app.console.channel.active': 'Servios activados',
  'app.console.channel.activateService': 'Empezar',
  'app.console.channel.learnMore': 'Más información',
  'app.console.channel.sendNum': 'Enviados',
  'app.console.channel.targetNum': 'Objetivos',
  'app.console.channel.deliveredNum': 'Entregados',
  'app.console.channel.clickNum': 'Clics',
  'app.console.channel.readNum': 'Lecturas',
  'app.console.channel.sendNumRate': 'Tasa de envío',
  'app.console.channel.deliveredNumRate': 'Tasa de entrega',
  'app.console.channel.clickNumRate': 'CTR',
  'app.console.channel.readNumRate': 'Tasa de lectura',
  'app.console.channel.title1': 'Tendencia en los últimos 7 días',
  'app.console.channel.title2': 'Conversión en los últimos 7 días',
  'app.console.channel.sendOut': 'Enviar mensaje',
  'app.console.channel.start': 'Comenzar',
  'app.console.channel.message.activated': 'activado',
  'app.console.channel.message.apppush':
    'Integración del SDK en 3 minutos para notificaciones push inteligentes que mejoran la retención.',
  'app.console.channel.message.email':
    'API de envío de emails con IP dedicada, autenticación BIMI y optimización de entregabilidad.',
  'app.console.channel.message.sms':
    'Funciones integradas de SMS que combinan comunicación celular e Internet para la dimensión global de las empresas.',
  'app.console.channel.message.whatsapp':
    'Utilice la API de WhatsApp Business para establecer conexiones más estrechas con más de dos mil millones de usuarios mundiales',
  'app.console.channel.message.OTP':
    'EngageLab OTP: generación y validación de contraseñas de un solo uso con entrega multicanal.',
  'app.console.channel.message.webpush':
    'EngageLab SMS: envío de mensajes de marketing y notificaciones a suscriptores para mejorar el engagement.',
  'app.console.channel.message.edm':
    'EngageLab Email: instalación con un clic y sin código para marketing y automatización que aumentan ingresos.',
  'app.console.channel.message.ma':
    'Servicios de Marketing Automation para gestión de datos y experiencias personalizadas de usuarios a través de múltiples canales.',
  'app.console.channel.message.captcha':
    'CAPTCHA de comportamiento, resolviendo pérdidas de negocios y riesgos de seguridad causados por ataques de automatización de scripts de máquina.',
  'app.console.channel.message.livedesk':
    'Plataforma de servicio al cliente omnicanal impulsada por IA que maneja el 90% de los problemas de los clientes.',
  'app.console.channel.message.silentauth':
    'Servicio de autenticación silenciosa que proporciona soluciones seguras y sin interrupciones para la verificación de identidad del usuario.',
  'app.console.channel.flag.email': 'Bandeja de Entrada',
  'app.console.doc': 'Documentación sobre la API REST',
  'app.console.doc.apppush': 'Documentación de AppPush',
  'app.console.doc.email': 'Documentación de Eamil',
  'app.console.doc.sms': 'Documentación de SMS',
  'app.console.doc.newsms': 'Documentación de SMS',
  'app.console.doc.whatsapp': 'Documentación WhatsApp',
  'app.console.doc.webpush': 'Documentación de WebPush',
  'app.console.doc.edm': 'Documentación de EDM',
  'app.console.doc.otp': 'Documentación de OTP',
  'app.console.doc.ma': 'Documentación de Marketing Automation',
  'app.console.doc.captcha': 'Documentación de CAPTCHA',
  'app.console.doc.livedesk': 'Documentación de LiveDesk',
  'app.console.doc.silentauth': 'Documentación de Silent Auth',
  'app.console.manage': 'Configuración',
  'app.console.manage.orders': 'Pedidos y facturas',
  'app.console.manage.pending': 'Pedidos pendientes de pago',
  'app.console.manage.supplementary': 'Facturas pendientes de pago',
  'app.console.manage.notification': 'Notificaciones',
  'app.console.manage.faq': 'Preguntas frecuentes',
  'app.console.manage.download': 'Descargas',
  'app.console.channel.verifiedRate': 'Tasa de relleno',
  'app.console.channel.verifiedNum': 'Cantidad de relleno',
  'app.console.channel.select.all': 'Todos',
  'app.console.channel.requestCount': 'Solicitudes',
  'app.console.channel.successCount': 'Exitosos',
  'app.console.channel.failCount': 'Fallidos',
  'app.console.channel.successRate': 'Tasa de éxito',
  'app.console.channel.failRate': 'Tasa de fallo',
};
